module.exports = __webpack_public_path__ + "static/media/loading.7d7c350b.gif";